import { Navigate, Outlet } from 'react-router-dom';
import { useActiveUser } from '../hooks/useActiveUser';
import LoadingSpinner from './LoadingSpinner';

export default function PublicRoute() {
  const { isLoading, isAuthed } = useActiveUser();
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-night-bg">
        <LoadingSpinner size="lg" />
      </div>
    );
  }
  if (isAuthed) return <Navigate to="/" replace />;
  return <Outlet />;
}
